import { FC } from 'react';

import './productBanner.scss';
import { IProductBannerDetails } from 'types';
import SectionTitle from 'pages/discoverPage/modularComponents/sectionTitle/SectionTitle';
import { Image } from 'components/helpers';

const ProductBanner: FC<{ details: IProductBannerDetails }> = ({ details }) => {
  const { borderColor, backgroundColor, borderWidth, text, image } = details;

  const borderStyle = `${borderWidth}px solid ${borderColor}`;

  return (
    <div
      style={{ border: borderStyle, background: backgroundColor }}
      className="product-banner-container"
    >
      <SectionTitle titles={text} onListClick={() => {}} />
      <Image src={image} />
    </div>
  );
};

export default ProductBanner;
